<template>
  <v-stepper-content step="2">
    <form>
      <v-container fluid>
        <v-row>
          <v-col cols="12" v-if="this.user.role !== 'client'">

          </v-col>
          <v-col cols="12" class="py-3  colored_labels" >
            {{$t('userRegistrationSteps.form.personalData')}}
          </v-col>

          <v-col cols="12" md="6" >
            <v-subheader>{{$t('userRegistrationSteps.form.firstname')}}</v-subheader>
            <v-text-field
                v-model="user.firstname"
                v-validate="'required|min:3'"
                :error-messages="errors.collect('firstname')"
                :label="$t('userRegistrationSteps.form.firstname_label')"
                data-vv-name="firstname"
                :data-vv-as="$t('userRegistrationSteps.form.firstname')"
                required
                solo
                height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-subheader>{{$t('userRegistrationSteps.form.lastname')}}</v-subheader>
            <v-text-field
                v-model="user.lastname"
                v-validate="'required|min:3'"
                :error-messages="errors.collect('lastname')"
                data-vv-name="lastname"
                :label="$t('userRegistrationSteps.form.lastname_label')"
                :data-vv-as="$t('userRegistrationSteps.form.lastname')"
                required
                solo
                height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-2  colored_labels" v-if="this.user.role ==='client'" >
            {{$t('userRegistrationSteps.form.informationsAboutShop')}}
          </v-col>
          <v-col cols="12" class="py-2  colored_labels" v-if="this.user.role ==='designer'" >
            {{$t('userRegistrationSteps.form.informationsAboutMarket')}}
          </v-col>


          <v-col cols="12" md="6" v-if="this.user.role ==='designer'">
            <v-subheader  v-if="this.user.role ==='designer'">{{$t('userRegistrationSteps.form.companyName')}}</v-subheader>
            <v-text-field
                v-model="user.addressAttributes.company"
                v-validate="'required|min:3|unique:vendor-name'"
                :error-messages="errors.collect('company_name')"
                :label="$t('userRegistrationSteps.form.companyNameLabel')"
                data-vv-name="company_name"
                data-vv-delay="500"
                :data-vv-as="$t('userRegistrationSteps.form.company_name')"
                required
                solo
                height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="this.user.role ==='client'">
            <v-subheader>{{$t('userRegistrationSteps.form.companyNameShop')}}</v-subheader>
            <v-text-field
                v-model="user.addressAttributes.company"
                v-validate="'required|min:3|unique:vendor-name'"
                :error-messages="errors.collect('company_name')"
                :label="$t('userRegistrationSteps.form.companyNameShopLabel')"
                data-vv-name="companyName"
                data-vv-delay="500"
                :data-vv-as="$t('userRegistrationSteps.form.company_name')"
                required
                solo
                height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" >
            <v-subheader>{{$t('userRegistrationSteps.form.phone_number')}}</v-subheader>
            <v-text-field
                v-model="user.phone_number"
                v-validate="'required|min:9'"
                :error-messages="errors.collect('phone_number')"
                data-vv-name="phone_number"
                :label="$t('userRegistrationSteps.form.phone_number_label')"
                :data-vv-as="$t('userRegistrationSteps.form.phone_number')"
                required
                solo
                height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-subheader  v-if="this.user.role ==='designer'">{{$t('userRegistrationSteps.form.address1')}}</v-subheader>
            <v-subheader  v-if="this.user.role ==='client'">{{$t('userRegistrationSteps.form.address1_client')}}</v-subheader>
            <v-text-field
                v-model="user.addressAttributes.address1"
                v-validate="'required|min:5'"
                :error-messages="errors.collect('address1')"
                data-vv-name="address1"
                :label="$t('userRegistrationSteps.form.address1_label')"
                :data-vv-as="$t('userRegistrationSteps.form.address1')"
                required
                solo
                height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-subheader> {{$t('userRegistrationSteps.form.zipcode')}} </v-subheader>
            <v-text-field
                v-model="user.addressAttributes.zipcode"
                v-validate="'required|min:3'"
                :error-messages="errors.collect('zipcode')"
                :label="$t('userRegistrationSteps.form.zipcode_label')"
                :data-vv-as="$t('userRegistrationSteps.form.zipcode')"
                data-vv-name="zipcode"
                required
                solo
                height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" >
            <v-subheader> {{$t('userRegistrationSteps.form.city')}} </v-subheader>
            <v-text-field
                v-model="user.addressAttributes.city"
                v-validate="'required|min:3'"
                :error-messages="errors.collect('city')"
                :label="$t('userRegistrationSteps.form.city')"
                :data-vv-as="$t('userRegistrationSteps.form.city')"
                data-vv-name="city"
                required
                solo
                height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-subheader> {{$t('userRegistrationSteps.form.country')}} </v-subheader>
            <v-select
                v-model="user.addressAttributes.country"
                v-validate="'required'"
                :error-messages="errors.collect('country')"
                :label="$t('userRegistrationSteps.form.country_label')"
                :data-vv-as="$t('userRegistrationSteps.form.country')"
                data-vv-name="country"
                :items="['Polska']"
                required
                solo
                height="43"
            ></v-select>
          </v-col>

          <v-col cols="12" class="py-3  colored_labels" v-if="this.user.role ==='designer'" >
            {{$t('userRegistrationSteps.form.detalis_accounts')}}
          </v-col>
          <v-col cols="12" md="6" v-if="this.user.role ==='designer'">
            <v-subheader> {{$t('userRegistrationSteps.form.number_detailist')}} </v-subheader>
            <v-select
                v-model="user.number_detailist"
                v-validate="'required'"
                :error-messages="errors.collect('number_detailist')"
                :label="$t('userRegistrationSteps.form.number_detailist')"
                :data-vv-as="$t('userRegistrationSteps.form.number_detailist')"
                data-vv-name="number_detailist"
                :items="['1-10','11-20','21-50','51-100','100+']"
                required
                solo
                height="43"
            ></v-select>
            <v-subheader> {{$t('userRegistrationSteps.form.main_category')}} </v-subheader>
            <v-select
                v-model="user.main_category"
                v-validate="'required'"
                :error-messages="errors.collect('main_category')"
                :label="$t('userRegistrationSteps.form.main_category')"
                :data-vv-as="$t('userRegistrationSteps.form.main_category')"
                data-vv-name="main_category"
                :items="['Dom i wnetrze','Moda i akcesoria','Ogrod','Biżuteria','Beauty and wellness','Sztuka cyrkularna','Dziecko','Ekolegiczne prezenty','Akcesoria papiernicze']"
                required
                solo
                height="43"
            ></v-select>
            <v-subheader> {{$t('userRegistrationSteps.form.instagram_link')}} </v-subheader>
            <v-text-field
                v-model="user.social_insta"
                :error-messages="errors.collect('social_insta')"
                :label="$t('userRegistrationSteps.form.instagram_link')"
                :data-vv-as="$t('userRegistrationSteps.form.instagram_link')"
                data-vv-name="social_insta"
                required
                solo
                height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="this.user.role ==='designer'">
            <v-subheader> {{$t('userRegistrationSteps.form.description_mark')}} </v-subheader>
            <v-textarea
                v-model="user.description"
                v-validate="'required'"
                :error-messages="errors.collect('description')"
                :label="$t('userRegistrationSteps.form.description_mark_solo')"
                :data-vv-as="$t('userRegistrationSteps.form.description')"
                data-vv-name="description"
                required
                solo
                rows="14"
                row-height="11"
            ></v-textarea>
          </v-col>

          <v-col cols="12" class="py-3  colored_labels" v-if="this.user.role ==='designer'" >
            {{$t('userRegistrationSteps.form.loginData')}}
          </v-col>
          <v-col cols="12" class="py-3  colored_labels" v-if="this.user.role ==='client'" >
            {{$t('userRegistrationSteps.form.loginData')}}
          </v-col>
          <v-col cols="12" md="6">
            <v-subheader> {{$t('userRegistrationSteps.form.email')}} </v-subheader>
            <v-text-field
              v-model="user.email"
              v-validate="'required|email|unique:user-email'"
              :error-messages="errors.collect('email')"
              :label="$t('userRegistrationSteps.form.email_label')"
              data-vv-name="email"
              data-vv-delay="500"
              :data-vv-as="$t('userRegistrationSteps.form.email')"
              required
             solo
              height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="user.role ==='client'">
            <v-subheader> {{$t('userRegistrationSteps.form.password')}} </v-subheader>
            <v-text-field
              v-model="user.password"
              v-validate="'required|min:6'"
              :error-messages="errors.collect('password')"
              :label="$t('userRegistrationSteps.form.password_label')"
              data-vv-name="password"
              :data-vv-as="$t('userRegistrationSteps.form.password')"
              type="password"
              required
             solo
              height="43"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="user.receiveLatestNews"
              :error-messages="errors.collect('receiveLatestNewsLabel')"
              data-vv-name="receiveLatestNewsLabel"
              :data-vv-as="$t('userRegistrationSteps.form.receiveLatestNewsLabel')"
              color="primary"
            >
              <template slot="label">
                <span v-html="$t('userRegistrationSteps.form.receiveLatestNewsDescription')"></span>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="user.termsAndConditions"
              v-validate="'required:true'"
              :error-messages="errors.collect('termsAndConditionsLabel')"
              data-vv-name="termsAndConditionsLabel"
              :data-vv-as="$t('userRegistrationSteps.form.termsAndConditionsLabel')"
              color="primary"
            >
              <template slot="label">
                <i18n path="userRegistrationSteps.form.termsAndConditionsDescription" tag="span">
                  <a href='terms-and-conditions' slot="terms" @click.stop target='_blank'>{{$t('userRegistrationSteps.form.termsAndConditionsLabel')}}</a>
                  <a href="privacy-policy" slot="privacy" @click.stop target="_blank">{{$t('userRegistrationSteps.form.privacyPolicyLabel')}}</a>
                </i18n>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="10" offset="1" xl="4" offset-xl="4" sm="8" offset-sm="2" lg="4" offset-lg="4" class="mt-3">
            <v-btn
              color="primary"
             solo
              depressed
              width="100%"
              height="43px"
              @click="goToNextStep"
              :loading="settings.formSubmitting"
            >
              {{saveButtonTranslation}}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </form>
  </v-stepper-content>
</template>

<script>
  export default {
    name: 'SecondStep',
    props: ['user', 'settings', 'customerType'],
    computed: {
      saveButtonTranslation() {
        if (this.user.role !== 'client') {
          return this.$t('userRegistrationSteps.stepper.next');
        } else {
          return this.$t('userRegistrationSteps.stepper.signUp');
        }
      },
    },
    methods: {
      goToNextStep() {
        this.$validator.validateAll().then(result => {
          if (result) {
              this.$emit('submitForm');
          }
        });
      },
      goBack() {
        this.$emit('goBack');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .col, .col-12 {
    padding-bottom: 0;
    padding-top: 0;
  }
</style>
